module.exports = __webpack_public_path__ + "img/1.61dd0911.png";